import { actionEqual } from './utils';
import * as ActionCreators from '../actions/ActionCreators';
import { uniqBy } from 'lodash';
import { DEFAULT_THUMBNAIL_URL } from 'constants/URL';

const defaultState: NewsFeedState = {
  newsFeedItems: [],
  selectedNewsFeed: null,
  newsFeeeItemsTotal: null,
  searchKey: '',
};

export enum MessageContentType {
  TEXT = 1,
  IMAGE = 2,
  FORM = 3,
  PDF = 5,
}

export enum MessageFromType {
  CHANNEL = 'ChannelBroadcast',
  ADMIN = 'AdminBroadcast',
  PRODUCT = 'ProductBroadcast',
}

const _parseMessage = (item: NewsFeedItem): NewsFeedViewItem => {
  const {
    channel_broadcast_message,
    product_description,
    message,
    timestamp_in_seconds,
    is_following,
  } = item;
  let data, channelID;
  if (channel_broadcast_message) {
    const {
      id,
      body,
      type: bodyType,
      company_channel: { display_logo, name },
    } = channel_broadcast_message;
    channelID = channel_broadcast_message.company_channel_id;
    data = {
      body,
      bodyType,
      name,
      avatar: display_logo,
      messageType: MessageFromType.CHANNEL,
      id: `${id}_channel_broadcast_message`,
    };
  } else if (product_description) {
    const {
      id,
      body,
      product: { name, channel_shop_item_category_id },
    } = product_description;
    data = {
      body,
      bodyType: MessageContentType.TEXT,
      name,
      avatar: DEFAULT_THUMBNAIL_URL,
      messageType: MessageFromType.PRODUCT,
      id: `${id}_product_description`,
      categoryId: channel_shop_item_category_id,
    };
  } else if (message) {
    const {
      id,
      body,
      type: bodyType,
      from_user: { display_name, profile_image_url_with_default },
    } = message;

    data = {
      body,
      bodyType,
      name: display_name,
      avatar: profile_image_url_with_default,
      messageType: MessageFromType.ADMIN,
      id: `${id}_message`,
    };
  }
  return {
    ...data,
    bodyType: Number(data.bodyType),
    timestamp: timestamp_in_seconds,
    isFollowing: is_following,
    channelID,
  };
};

export default function newsFeed(
  state: NewsFeedState = defaultState,
  action: Action
): NewsFeedState {
  if (actionEqual(action, ActionCreators.setNewsFeedResponse)) {
    const { items, total } = action.payload.newsFeedResponse;

    // Generate manually id for message
    const transformItems = items.map(item => _parseMessage(item));
    return {
      ...state,
      newsFeedItems: uniqBy([...state.newsFeedItems, ...transformItems], 'id'),
      newsFeeeItemsTotal: total,
    };
  } else if (actionEqual(action, ActionCreators.setSelectedNewsFeed)) {
    const { newsFeed } = action.payload;
    return {
      ...state,
      selectedNewsFeed: newsFeed,
    };
  } else if (actionEqual(action, ActionCreators.setFollowChannelStatus)) {
    const { newsFeedItems } = state;
    const { channelID } = action.payload;
    return {
      ...state,
      newsFeedItems: newsFeedItems.map(item => {
        return {
          ...item,
          isFollowing: item.channelID === channelID ? true : item.isFollowing,
        };
      }),
    };
  } else if (actionEqual(action, ActionCreators.setSearchNewsFeedKeyword)) {
    return {
      ...state,
      searchKey: action.payload.searchKey,
    };
  } else if (actionEqual(action, ActionCreators.clearNewsFeedItems)) {
    return {
      ...state,
      newsFeedItems: [],
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/newsFeed.ts